/**
 * TAAR — component-variant-picker.js
 * Handles variant selection: availability states, URL update, event emission.
 * Depends on window.TAAR (taar-global.js).
 */

(function () {
  'use strict';

  class TaarVariantPicker extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this._init(), { once: true });
      } else {
        this._init();
      }
    }

    _init() {
      this._productId = parseInt(this.dataset.productId, 10);

      // Parse variants JSON from embedded script tag
      var jsonEl = this.querySelector('[data-variants-json]');
      this._variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

      // Collect all option inputs (radio + select)
      this._inputs = Array.from(
        this.querySelectorAll('.variant-picker__radio, .variant-picker__select')
      );

      var self = this;
      this._inputs.forEach(function (input) {
        input.addEventListener('change', function () { self._onInputChange(); });
      });

      this._markUnavailableOptions();
    }

    _onInputChange() {
      this._markUnavailableOptions();

      var variant = this._findSelectedVariant();
      if (!variant) return;

      // Update hidden variant ID input (lives inside this custom element)
      var hiddenInput = this.querySelector('[data-variant-id-input]');
      if (hiddenInput) hiddenInput.value = variant.id;

      // Update displayed option values in headers
      var self = this;
      this.querySelectorAll('[data-option-selected-value]').forEach(function (el) {
        var idx   = parseInt(el.dataset.optionSelectedValue, 10);
        var input = self._inputs.find(function (i) {
          return parseInt(i.dataset.optionIndex, 10) === idx &&
                 (i.type !== 'radio' || i.checked);
        });
        if (input) el.textContent = input.value;
      });

      // Update URL without reload
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Emit event — product page reacts (price, images, add-to-cart state)
      if (window.TAAR) {
        TAAR.EventBus.emit('variant:changed', {
          productId: this._productId,
          variant:   variant
        });
      }
    }

    _getSelectedValues() {
      var values = {};
      this._inputs.forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        if (input.tagName === 'SELECT') {
          values[idx] = input.value;
        } else if (input.checked) {
          values[idx] = input.value;
        }
      });
      return values;
    }

    _findSelectedVariant() {
      var selected = this._getSelectedValues();
      return this._variants.find(function (v) {
        return v.options.every(function (val, idx) {
          return selected[idx] === val;
        });
      }) || null;
    }

    _markUnavailableOptions() {
      var self     = this;
      var selected = this._getSelectedValues();

      this._inputs.forEach(function (input) {
        if (input.tagName !== 'INPUT') return;

        var optionIdx  = parseInt(input.dataset.optionIndex, 10);
        var testValues = Object.assign({}, selected);
        testValues[optionIdx] = input.value;

        var matchingVariant = self._variants.find(function (v) {
          return v.options.every(function (val, idx) {
            return testValues[idx] === val;
          });
        });

        var available = matchingVariant ? matchingVariant.available : false;
        var label = input.nextElementSibling; // <label> (swatch) follows each <input>

        if (label) {
          label.classList.toggle('is-unavailable', !available);
          label.setAttribute('aria-disabled', available ? 'false' : 'true');
        }
      });
    }
  }

  if (!customElements.get('taar-variant-picker')) {
    customElements.define('taar-variant-picker', TaarVariantPicker);
  }

}());
